module.exports = __webpack_public_path__ + "7acaf27b6bb6ed2fa906663a1aaf4e8a.pdf";